// inv/src/pages/solutions/accelerators-incubators/blocks/AcceleratorsDiscoverSection.jsx
import { useTranslation } from 'react-i18next';
import CTAHover from '../../../../components/ui/CTAHover';
import { CheckCircle2 } from 'lucide-react';

const AcceleratorsDiscoverSection = ({ bgColor = 'bg-white' }) => {
  const { t } = useTranslation();

  return (
    <section className={`py-16 sm:py-24 ${bgColor}`}>
      <div className="w-[75%] mx-auto max-w-screen-xl lg:grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <h3 className="text-2xl text-blue-600 font-bold mb-4">
            {t(
              'pageSolutions.AcceleratorsIncubators.t3',
              'Crino for accelerators & incubators'
            )}
          </h3>
          <h2 className="text-3xl sm:text-4xl font-semibold text-stone-900">
            {t(
              'pageSolutions.AcceleratorsIncubators.t4',
              'Help your startups connect with the right investors'
            )}
          </h2>

          <p className="mt-6 text-base leading-7 text-stone-700">
            {t(
              'pageSolutions.AcceleratorsIncubators.t5',
              'Easily map active investors by sector, geography, ticket size and round type. Provide your founders with the right warm leads instead of broad lists.'
            )}
          </p>

          <ul className="mt-6 space-y-4 text-base leading-7 text-stone-700">
            <li className="flex items-start gap-3">
              <span className="mt-1 inline-flex h-6 w-6 items-center justify-center rounded-full bg-blue-50">
                <CheckCircle2 className="h-4 w-4 text-blue-600" />
              </span>
              <span>
                {t(
                  'pageSolutions.AcceleratorsIncubators.t6',
                  'Filter investors by thesis, ticket size, preferred round and portfolio focus.'
                )}
              </span>
            </li>

            <li className="flex items-start gap-3">
              <span className="mt-1 inline-flex h-6 w-6 items-center justify-center rounded-full bg-blue-50">
                <CheckCircle2 className="h-4 w-4 text-blue-600" />
              </span>
              <span>
                {t(
                  'pageSolutions.AcceleratorsIncubators.t7',
                  'See startups they recently backed, including deal sizes, stages and co-investors.'
                )}
              </span>
            </li>

            <li className="flex items-start gap-3">
              <span className="mt-1 inline-flex h-6 w-6 items-center justify-center rounded-full bg-blue-50">
                <CheckCircle2 className="h-4 w-4 text-blue-600" />
              </span>
              <span>
                {t(
                  'pageSolutions.AcceleratorsIncubators.t8',
                  'Use AI matching to identify investors most likely to fund each startup in your cohort.'
                )}
              </span>
            </li>

            <li className="flex items-start gap-3">
              <span className="mt-1 inline-flex h-6 w-6 items-center justify-center rounded-full bg-blue-50">
                <CheckCircle2 className="h-4 w-4 text-blue-600" />
              </span>
              <span>
                {t(
                  'pageSolutions.AcceleratorsIncubators.t9',
                  'Find comparable startups and benchmark fundraising strategies for your founders.'
                )}
              </span>
            </li>
          </ul>

          <CTAHover
            className="mt-8"
            text={t(
              'pageSolutions.AcceleratorsIncubators.t10',
              'Start supporting your cohorts with actionable investor insights'
            )}
            href="pricing/"
            align="left"
            bgColor="bg-blue-600 text-white"
            textColor="text-stone-800"
            hoverTextColor="text-white"
          />
        </div>

        <div className="mt-12 lg:mt-0 grid grid-cols-1 gap-4">
          <img
            className="w-full"
            src="https://crino-cdn.nyc3.cdn.digitaloceanspaces.com/pages-images/solutions/crino-ai-funding-assistant.png"
            alt={t(
              'pageSolutions.AcceleratorsIncubators.alt1',
              'Investor mapping tools for accelerators and incubators'
            )}
          />
        </div>
      </div>
    </section>
  );
};

export default AcceleratorsDiscoverSection;
